import React, { useEffect, useState } from "react";
import { SquareTitle } from "../../../../components";
import { useSettings } from "../../../../context";
import { formatDateToChinese } from "../Advertorials";
import {
  getPressData,
  pressListLanguageMap,
  type PressListData,
} from "../../../../utils";

export const PressReleases: React.FC = () => {
  const { getSingleText, language, processText } = useSettings();
  const [pressList, setPressList] = useState<PressListData[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(pressListLanguageMap[language]);
      const data = await response.json();
      setPressList(getPressData(data));
    };
    fetchData();
  }, [language]);

  return (
    <div className="flex flex-col gap-[24px]">
      <SquareTitle title={getSingleText("Press Releases", "新聞公報")} />
      {pressList.map((item: PressListData, i) => {
        const { title, url, date } = item;

        return (
          <div key={i} className="flex flex-col">
            <a
              className="text-heading-m !underline !underline-offset-4 mb-[16px] !text-[#203136]"
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={processText(title)}
            >
              {processText(title)}
            </a>
            <div className="flex flex-row items-center">
              <img
                className="w-[16px] h-[16px] mr-[8px]"
                src={`${process.env.PUBLIC_URL}/assets/icons/calendar.svg`}
                alt={date}
              />
              <span>{getSingleText(date, formatDateToChinese(date))}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
